import { WysiwygRenderer } from "@ui/components/wysiwyg-renderer/wysiwyg-renderer";
import { WysiwygContent } from "@uxf/wysiwyg/Content";
import React, { FC } from "react";

export interface SectionProps {
    content?: WysiwygContent;
    type: "wysiwyg" | string;
}

const Section: FC<SectionProps> = ({ content, type }) => {
    switch (type) {
        case "wysiwyg":
            return <WysiwygRenderer data={content} />;
        default:
            return null;
    }
};

interface Props {
    sections: SectionProps[];
}

export const SectionRenderer: FC<Props> = ({ sections }) => (
    <>
        {sections.map(({ type, content }, index) => (
            <Section content={content} key={index.toString()} type={type} />
        ))}
    </>
);
